import React, { useState } from 'react';

const CoachDisableConfirmationModal = ({ onClose, handleSubmit, message, title }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePrimaryAction = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        const result = handleSubmit?.();
        if (result && typeof result.finally === "function") {
            result.finally(() => setIsSubmitting(false));
        }
    };
    return (
        <div
            className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content">
                    <div class="modal-body py-5">
                        <div class="mx-auto d-block text-center mb-4">
                            <svg
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                                    fill="#023047"
                                />
                            </svg>
                        </div>
                        <div class="text-center">
                            <h4 class="ct_fs_20">{title}</h4>
                            <p>
                                {message}
                            </p>
                        </div>
                        <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                            <button
                                class="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                                onClick={onClose}
                            >
                                Close
                            </button>
                            <button
                                class="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn"
                                data-bs-dismiss="modal"
                                onClick={handlePrimaryAction}
                                type="button"
                                disabled={isSubmitting}
                            >
                                Disable
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CoachDisableConfirmationModal;
